import Text from 'components/Text';
import styled from 'styled-components/native';

export const Container = styled.View`
  margin-bottom: 24px;
  margin-top: 8px;
`;

export const Content = styled.View`
  padding: 32px 16px;
`;

export const Footer = styled.View``;

export const Header = styled.View`
  align-items: center;

  width: 218px;
  margin: 0 auto;
`;

export const InvoiceImage = styled.Image`
  width: 100px;
  height: 88px;

  margin-bottom: 16px;
`;

export const Title = styled(Text)`
  color: ${props => props.theme.colors.base.slot1};
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 16px;

  margin-bottom: 4px;
`;

export const Subtitle = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot4};
  font-size: 14px;
  text-align: center;
`;

export const InvoiceDescriptionItem = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding-top: 16px;

  padding-bottom: ${props => props.border && '16px'};
  border-bottom-color: ${props => props.theme.colors.grayscale.slot2};
  border-bottom-width: ${props => (props.border ? '1px' : 0)};
  border-style: solid;
  border-width: 0;
`;

export const InvoiceDescriptionTitle = styled(Text)`
  font-size: 13px;
`;

export const InvoiceDescriptionValue = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[500]};
`;

export const FilledButton = styled.TouchableOpacity`
  padding: 16px 0px;
  background-color: ${props => props.theme.colors.base.slot1};
  width: 100%;
  height: 50px;
  text-align: center;
  border-radius: 30px;
`;

export const FilledButtonText = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot1};
  font-size: 16px;
`;

export const TransparentButton = styled.TouchableOpacity`
  width: 100%;
  margin-top: 16px;
  text-align: center;
`;

export const TransparentButtonText = styled(Text)`
  color: ${props => props.theme.colors.base.slot1};
  font-size: 14px;
`;

export const BarCodeContainer = styled.View`
  background-color: ${props => props.theme.colors.grayscale.slot2};
  padding: 16px;
  margin-top: 32px;
  border-radius: 5px;
`;

export const BarCode = styled(Text)`
  color: ${props => props.theme.colors.grayscale.slot6};
  font-size: 12px;
  text-align: center;
  letter-spacing: 1px;
`;
